// App.js — Root component with client-side routing
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login        from './components/Login';
import Register     from './components/Register';
import Dashboard    from './components/Dashboard';
import Companies    from './components/Companies';
import Applications from './components/Applications';
import './App.css';

// ProtectedRoute: redirects to /login if no student session exists
function ProtectedRoute({ children }) {
  const student = JSON.parse(localStorage.getItem('student'));
  return student ? children : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login"    element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Protected routes */}
        <Route path="/dashboard" element={
          <ProtectedRoute><Dashboard /></ProtectedRoute>
        } />
        <Route path="/companies" element={
          <ProtectedRoute><Companies /></ProtectedRoute>
        } />
        <Route path="/applications" element={
          <ProtectedRoute><Applications /></ProtectedRoute>
        } />

        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}
